import { Autocomplete, TextField } from "@mui/material";

export type TruxAutocompleteOption = {
  id: number,
  label: string
}
export type TruxAutocompleteProps = {
  options: TruxAutocompleteOption[]
  selected: TruxAutocompleteOption,
  label?: string,
  freeSolo?: boolean,
  onChange: (selection: null | TruxAutocompleteOption) => void,
  onClear: () => void,
  noOptionsText?: string,
}
export default function TruxAutocompleteField({ options, selected, noOptionsText = "", onChange, onClear, label, freeSolo = true }: TruxAutocompleteProps) {
  return <Autocomplete
    disablePortal
    size="small"
    options={options}
    freeSolo={freeSolo}
    forcePopupIcon
    onClose={() => {
      onChange(null);
    }}
    onChange={(e, value, reason) => {
      if (typeof value === "string") {
        return;
      }
      
      if (value !== null) {
        onChange(value);
      } else if (reason === "clear" && e.type === "click") {
          onClear();
          setTimeout(() => {
            (document.activeElement as any)?.blur();
          }, 50);
        }
    }}
    noOptionsText={noOptionsText || "Please add a Business Partner"}
    sx={{ width: "100%" }}
    value={selected}
    renderOption={(props, option: TruxAutocompleteOption) => (
      <li {...props} key={option.id}>{option.label}</li>
    )}
    renderInput={(params) => <TextField label={label} {...params} />}
  />
}